import DocumentRequestsAPI from './documentRequests';

// Tramite-scoped document-request checklist singleton.
// Owner id is the tramite id (the URL identifier for nested tramite routes).
export default new DocumentRequestsAPI('tramites');
